<template>
  <v-row row justify-center>
    <v-dialog v-model="displayForm" persistent max-width="980px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline" v-if="item">Update Shop</span>
            <span class="headline" v-else>Add Shop</span>
          </v-card-title>
          <div class="text-xs-center">
            <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
          </div>
          <v-card-text v-if="!loading">
            <v-alert
              :value="message"
              type="error"
              dismissible
              transition="scale-transition"
              v-if="errorCount==1"
            >{{ message }}</v-alert>

            <v-container grid-list-md>
              <v-row wrap>
                <v-col cols="4">
                  <v-text-field v-model="model.name" label="Name" :rules="mandatoryRules"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select :items="shopTypes" v-model="model.type" label="Shop Type"></v-select>
                </v-col>
                <v-col cols="4">
                  <v-select :items="clientTypes" v-model="model.clientTypeId" label="Client Type"></v-select>
                </v-col>
                <v-col cols="4">
                  <v-select :items="catalogs" v-model="model.catalog_id" label="Catalog" item-text="name" item-value="id" :rules="mandatoryRules"></v-select>
                </v-col>
                <v-col cols="4">
                  <v-text-field type="number" v-model="model.retailer_percent" label="Retailer percent"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <customer v-model="model.client_id" label="Billing Client"/>
                </v-col>
                <v-col cols="4">
                  <location v-model="model.location_id" />
                </v-col>
                <v-col cols="4">
                  <tax-rate v-model="model.tax_rate_id" :locationId="model.location_id" />
                </v-col>
                <v-col cols="4">
                  <v-text-field type="string" v-model="model.logo" label="Logo"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-textarea v-model="model.quote_header" label="Quote header" />
                </v-col>
                <v-col cols="6">
                  <v-textarea v-model="model.quote_footer" label="Quote footer" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
            <v-btn
              v-if="item"
              color="blue darken-1"
              text
              @click="update()"
              :disabled="loading"
            >Update</v-btn>
            <v-btn v-else color="blue darken-1" text @click="add()" :disabled="loading">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import Customer from '../../../components/forms/autocomplete/Customer.vue';
import Location from '../../../components/forms/autocomplete/Location.vue';
import TaxRate from '../../../components/forms/select/TaxRate.vue';
function getDefaultData() {
  return {
    model: {
      id: null,
      name: null,
      currency: null,
      locationId: null
    },
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    message: null,
    valid: null,
    clientTypes: [
      { value: "b2b", text: "B2B" },
      { value: "b2c", text: "B2C" }
    ],
    shopTypes: [
      { value: "main", text: "Main" },
      { value: "retailer", text: "Retailer" }
    ],
    errorCount: 0,  
  };
}
export default {
  components: { Customer, TaxRate, Location },
  props: ["item", "open", "id"],
  data: getDefaultData,
  computed: {
    ...mapGetters("catalogs", ["catalogs"]),
    displayForm: function() {
      return this.open;
    },
    loading: function() {
      return this.$store.getters["shops/loading"];
    }
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
    }
  },
  methods: {
    add() {
      if (this.$refs.form.validate()) {
        this.model.locationId = this.id;
        this.$store
          .dispatch("shops/add", {
            model: this.model
          })
          .then(result => {
            console.log(result)
            if (result.shop.id) {
              this.$emit("add");
              this.resetForm();
            } else {
              this.errorCount=1;
              this.message = result.shop.message;
            }
            this.flashMessage.success({
              message: "Shop created successfully",
            });
          })          
          .catch(result => {
            console.log(result);
            this.flashMessage.error({
              message: "Fail to create Shop",
            });
          });
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("shops/update", {
            model: this.model
          })
          .then(result => {
            console.log(result);
            if (result.shop.id) {
              this.$emit("update");
              this.resetForm();
            } else {
              this.errorCount=1;
              this.message = result.shop.message;
            }
            this.flashMessage.success({
              message: "Shop updated successfully",
            });
          })
          .catch(result => {
            console.log(result);
            this.flashMessage.error({
              message: "Fail to update shop",
            });
          });
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
